import {
  IAppLogPageRequestParams,
  IDownloadRequest,
  ILogInfoListResponse,
} from "api/entities/logs";
import { DataService } from "./data-service";

class LogsService extends DataService {
  constructor() {
    super("logs", 2);
  }

  getLogs(
    requestParams: IAppLogPageRequestParams,
  ): Promise<ILogInfoListResponse> {
    return this.api.get<ILogInfoListResponse>("list", requestParams);
  }

  download(request: IDownloadRequest): Promise<ArrayBuffer> {
    return this.api.post<ArrayBuffer>("download", request);
  }
}

export const logService = new LogsService();
